<div class="homepage-container">
  <!-- video/top-container -->
  <div
    #backgroundContainer
    class="top-container-background"
  >
    <img
      #backgroundImage
      class="background-image"
      src="{{ homepageImageUrl }}"
      imgErrLog
    />
    <video
      #backgroundVideo
      class="background-video"
      loop
      autoplay
      muted
      playsinline
    >
      <source
        src="{{ homepageVideoUrl }}"
        type="video/mp4"
      />
    </video>

    <div class="top-container">
      <div class="top-container-inflex">
        <div class="headline">
          LET'S GET TOGETHER.
          <div class="sub-headline">Event Planning&mdash;as it should be.</div>
        </div>

        <div
          class="invitation-message"
          *ngIf="showInvitation"
        >
          <span class="partnerName">{{ partnerName }}</span> sent you an invitation to join {{ PRODUCT_NAME }}
        </div>

        <a
          class="top-cta-button"
          [routerLink]="topCtaLink"
          [queryParams]="topCtaQueryParams"
          merriNoFocusLink
          id="homepage-floating-sign-up-button-anchor"
        >
          <span class="top-cta-label">{{ topCtaText | uppercase }}</span>
          <mat-icon
            svgIcon="arrow_forward"
            class="top-cta-icon"
          ></mat-icon>
        </a>
        <div
          class="venue-join-cta"
          *ngIf="showVenueJoinCta"
        >
          <span>Are you a venue?</span><a [routerLink]="LEARN_MORE_VENUE_LINK">Learn More</a>
        </div>

        <mat-icon
          class="top-cta-jumper"
          svgIcon="chevron_down"
          (click)="onTopCtaJumperClick()"
          *ngIf="ctaJumpTo"
        ></mat-icon>
      </div>
    </div>
  </div>

  <!-- blurb-container -->
  <div
    #ctaJumpTo
    class="blurb-container"
  >
    <mat-icon
      class="icon-logo"
      [svgIcon]="brandingService.logoMarkOutlineIcon"
    ></mat-icon>
    <div class="blurb">
      <div class="blurb-header">Meet {{ PRODUCT_NAME }}.</div>
      We're simplifying how you get together with the all-in-one platform that customizes your vision in real-time—then brings it all to
      life in 3D.
    </div>
  </div>

  <app-swatch
    class="how-it-works-swatch"
    [color]="AppColors.OffWhite"
  >
    <div class="how-it-works-container">
      <div class="how-it-works-title-wrapper"><span class="how-it-works-title">HOW IT WORKS</span></div>

      <ng-container *ngFor="let info of howItWorksWidgets">
        <app-homepage-how-it-works-widget
          class="how-it-works-widget"
          [info]="info"
        ></app-homepage-how-it-works-widget>
      </ng-container>
    </div>

    <div class="other-features-container">
      <div class="homepage-section-header">
        EXCLUSIVE FEATURES
        <div class="homepage-section-subheader">Brought to you by {{ PRODUCT_NAME }}.</div>
      </div>

      <div class="other-features-wrapper">
        <ng-container *ngFor="let info of otherFeaturesCards">
          <app-display-card
            class="other-features-widget"
            [info]="info"
          ></app-display-card>
        </ng-container>
      </div>
    </div>
  </app-swatch>

  <div class="featured-partners-container">
    <app-homepage-featured-partners></app-homepage-featured-partners>
  </div>

  <div class="venue-join-container">
    <app-homepage-venue-join></app-homepage-venue-join>
  </div>

  <div class="testimonial-container">
    <app-testimonial-display></app-testimonial-display>
  </div>
</div>
